import {DataTransferObject} from './DataTransferObject';
import {TicketConfiguration} from '../Models';

export class TicketConfigurationDTO extends DataTransferObject {
  public id: number | string = 0;
  public productId: number | string = 0;
  public slotId: number | string | null = null;
  public parentId: number | string | null = null;
  public quantity: number = 0;
  public personalUse: boolean = false;
  public subTicketConfigurations: Array<TicketConfigurationDTO> = [];
  public registrationRequired: string = '';

  fromModel(ticketConfiguration: TicketConfiguration): TicketConfigurationDTO {
    const ticketConfigDTO = new TicketConfigurationDTO();
    if (ticketConfiguration.product.id === null) {
      throw new Error('Product ID needs to be valid.');
    }

    ticketConfigDTO.id = ticketConfiguration.id;
    ticketConfigDTO.productId = ticketConfiguration.product.id;
    ticketConfigDTO.parentId = ticketConfiguration.parentId;
    ticketConfigDTO.personalUse = ticketConfiguration.personalUse;
    ticketConfigDTO.quantity = ticketConfiguration.quantity;
    ticketConfigDTO.registrationRequired = ticketConfiguration.registrationRequired;

    ticketConfiguration.subTicketConfigurations.forEach((subConfig) => {
      ticketConfigDTO.subTicketConfigurations.push(new TicketConfigurationDTO().fromModel(subConfig));
    });

    if (ticketConfiguration.slot) {
      ticketConfigDTO.slotId = ticketConfiguration.slot.id;
    }
    return ticketConfigDTO;
  }

  static clone(ticketConfigurationDTO: TicketConfigurationDTO): TicketConfigurationDTO {
    const clone = new TicketConfigurationDTO();
    clone.id = ticketConfigurationDTO.id;
    clone.productId = ticketConfigurationDTO.productId;
    clone.parentId = ticketConfigurationDTO.parentId;
    clone.slotId = ticketConfigurationDTO.slotId;
    clone.subTicketConfigurations = ticketConfigurationDTO.subTicketConfigurations.map(stc => TicketConfigurationDTO.clone(stc));
    clone.quantity = ticketConfigurationDTO.quantity;
    clone.personalUse = ticketConfigurationDTO.personalUse;
    clone.registrationRequired = ticketConfigurationDTO.registrationRequired;
    return clone;
  }

  get isProductFamily() {
    return this.subTicketConfigurations.length > 0;
  }

  get isSubProduct() {
    return this.parentId !== null;
  }
}
